import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
//引入element ui
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
// 路由跳转时定位到页面顶部
router.afterEach((to, from, next) => {
    document.body.scrollTop = 0;
    document.documentElement.scrollTop = 0;
});
// v3 动画
import vue3SeamlessScroll from 'vue3-seamless-scroll';
createApp(App).use(store).use(vue3SeamlessScroll).use(ElementPlus).use(router).mount('#app')
